import React, { useState, useEffect } from "react";
import "./App.css";
import Tesseract from "tesseract.js";
import TextWrapper from "./components/TextWrapper";
import ImageWrapper from "./components/ImageWrapper";
import Footer from "./components/Footer" ;
import axios from "axios";
import logo from "../src/images/eagle.jpg";
import { BrowserRouter as Router, Link} from "react-router-dom";

// create account on imgbb and go to > about section > and get that api key and put it here

// const API_KEY = "PUT_YOUR_API_KEY_HERE";

function App() {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [text, setText] = useState(null);

  const convertImageToText = async () => {
    setLoading(true);
    const result = await Tesseract.recognize(imageUrl, "eng");
    setText(result.data.text);
    setLoading(false);
  };

  const uploadFile = async e => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("image", e.target.files[0]);
      const config = {
        headers: {
          "content-type": "multipart/form-data"
        }
      };

      const res = await axios.post(
        "https://api.imgbb.com/1/upload?key=8bd70fef0b8353f332b97ecd7108a871",       
        formData,
        config
      );
      setImageUrl(res.data.data.url);
      setLoading(false);
    } catch (error) {
      console.log(error.message);
    }
  };
   useEffect(() => {
    if (imageUrl != null) {
      convertImageToText();
    }
  }, [imageUrl]);
  
  return (
    <div className="App">
        <Router>
      
      <Link to="/" onClick={() => window.location.reload(false)} className="navbar-brand">

      <img src={logo} className="logo" alt="" />
      </Link>
      <div className="container">
        {loading && <div className="loader"></div>}
        {text == null ? (
          <ImageWrapper loading={loading} uploadFile={uploadFile} />
        ) : (
          <TextWrapper text={text} />
        )}
      </div>
      <Footer />
      </Router>
    </div>
  );
}

export default App;
